const sortValuesPrispevkyVestnika = ['datumZverejnenia', 'nazovSort', 'cisloSort'];
const defaultSortPrispevkyVestnika = 'datumZverejnenia';

export {
  sortValuesPrispevkyVestnika, defaultSortPrispevkyVestnika,
};
